import React from "react";

import { Checkbox } from "@material-ui/core";

const CardComponent = (props) => {
  return (
    <div className="container-margin">
      <div className="new-investor-card-header">
        {props.title.toUpperCase()}
      </div>
      <div
        className={
          !props.style ? "new-investor-card" : "new-investor-card-active"
        }
      >
        {props.children}
      </div>
    </div>
  );
};
export const CardComponentBank = (props) => {
  return (
    <div className="container-margin">
      <div className="new-investor-card-header">
        {props.title.toUpperCase()}
        <Checkbox
          checked={props.isBankSame}
          onChange={props.setIsBank}
          style={{
            marginLeft: "30px",
            cursor: "pointer",
            color: "#003d7b",
          }}
        ></Checkbox>
        Bank details same as Tier I
      </div>
      {!props.isBankSame && (
        <div className="new-investor-card">{props.children}</div>
      )}
    </div>
  );
};

const SummaryCard = (props) => {
  return (
    <>
      <div className="container-margin">
        <div className="new-investor-summary-card-header">{props.title}</div>
        <div className="new-investor-summary-card">{props.children}</div>
      </div>
    </>
  );
};

export default CardComponent;
export { SummaryCard };
